import React from 'react';
import PropTypes from 'prop-types';
import {
  SimpleModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@ami/react/core';
import { AsyncFormDropdown } from '@ami/react/core';
import { FormDropdown as Dropdown } from '@ami/react/core';
import { Button } from '@ami/react/core';
import { DealerGroup } from '../../dealer-groups/dealerGroup';
import { DealerGroupFilter } from '../../dealer-groups/dealerGroupFilter';
import { FormReadonly } from '@ami/react/core';
import { DealerBranch } from '../../dealer-branches/dealerBranch';
import { Quote } from '../../quotes/quote';
import NotificationSettings from '../../notificationSettings';
import { User } from '../../users/user';
import { DealerUserFilter } from '../../dealer-users/dealerUserFilter';
import { appConfig } from '@ami/react/core';
import { Team } from '../../teams/team';
import { dealerUserService } from '../../dealer-users/dealerUserService';
import QuoteView from '../../quotes/view/quoteView';
import { NotificationSettingsComponent } from '../../NotificationSettingsComponent';

export default class ChangeBranchModal extends React.Component {
  state = {
    show: false,
    dealerBranches: [],
    dealerUsers: [],
    selectedGroup: null,
    selectedBranchId: null,
    selectedUserId: null,
    saving: false,
    // The properties below are used in the notification settings modal.
    dealerBranch: null,
    dealerGroup: null,
    amiUsers: [],
    dealerBranchSalesTeam: null,
    notificationSettings: new NotificationSettings(),
  };

  static propTypes = {
    quote: PropTypes.instanceOf(QuoteView).isRequired,
    onChanged: PropTypes.func.isRequired,
  };

  async componentDidUpdate(prevProps, prevState) {
    if (!prevState.show && this.state.show) {
      const { dealerInformation } = this.props.quote;
      const state = {
        dealerUsers: [],
        selectedGroup: {
          id: dealerInformation.dealerGroupId,
          label: dealerInformation.dealerGroupName,
        },
        selectedBranchId: null,
        selectedUserId: dealerInformation.dealerUserId,
        dealerGroup: null,
        notificationSettings: new NotificationSettings(),
      };
      if (this.state.dealerBranches.length === 0) {
        state.dealerBranches = await DealerBranch.search();
      }
      this.setState(state);
    }
  }

  show = () => this.setState({ show: true, loading: true });
  hide = () => this.setState({ show: false });

  save = () => {
    this.setState({ saving: true });
    const { selectedBranchId, selectedUserId, notificationSettings } =
      this.state;
    Quote.changeDealerBranch(
      this.props.quote.id,
      selectedBranchId,
      selectedUserId,
      notificationSettings
    )
      .then(() => {
        this.props.onChanged();
        this.hide();
      })
      .finally(() => this.setState({ saving: false }));
  };

  async changeGroup(selectedGroup) {
    this.setState({
      selectedGroup,
      selectedBranchId: null,
      selectedUserId: null,
    });
  }

  async changeBranch(selectedBranchId) {
    this.setState({ selectedBranchId });

    const dealerUsers = selectedBranchId
      ? await dealerUserService.search(
          new DealerUserFilter({
            dealerGroupId: this.state.selectedGroup.id,
            dealerBranchId: selectedBranchId,
          })
        )
      : [];

    this.setState({ dealerUsers });

    if (appConfig.isManagementApp)
      await this.setStateForNotificationSettings(selectedBranchId);
  }

  async setStateForNotificationSettings(selectedBranchId) {
    if (selectedBranchId) {
      const dealerBranch = await DealerBranch.getById(selectedBranchId);
      this.setState({
        dealerBranch,
        dealerGroup: await DealerGroup.getById(dealerBranch.dealerGroupId),
        amiUsers: await User.search(),
        dealerBranchSalesTeam: await Team.getById(dealerBranch.salesTeamId),
      });
    } else {
      this.setState({
        dealerBranch: null,
        dealerGroup: null,
        amiUsers: [],
        dealerBranchSalesTeam: null,
      });
    }
  }

  updateNotificationSettings = (notificationSettings) => {
    this.setState({ notificationSettings });
  };

  render() {
    const {
      show,
      dealerBranches,
      selectedGroup,
      selectedBranchId,
      selectedUserId,
      dealerBranch,
      dealerGroup,
      dealerUsers,
      amiUsers,
      dealerBranchSalesTeam,
      notificationSettings,
    } = this.state;
    if (!show) return null;
    const { quote } = this.props;
    const dealerUser = dealerUsers.find((x) => x.id === selectedUserId);
    return (
      <SimpleModal show={show} size="lg">
        <ModalHeader title="Change Branch" />
        <ModalBody>
          <form className="container">
            <div className="row">
              <div className="col">
                <FormReadonly
                  label="Current Branch"
                  value={quote.dealerInformation.dealerBranchName}
                />
              </div>
            </div>
            <div className="row">
              {appConfig.isManagementApp && (
                <div className="col-md-6">
                  <AsyncFormDropdown
                    label="Dealer Group"
                    fetchItems={async (name) =>
                      DealerGroup.search(
                        new DealerGroupFilter({ name, $top: 10 })
                      )
                    }
                    mapItemsToDropdownItems={(items) =>
                      items.map((x) => ({ id: x.id, label: x.name }))
                    }
                    placeholder="Select a dealer group..."
                    selected={selectedGroup}
                    onChange={(selectedGroup) =>
                      this.changeGroup(selectedGroup)
                    }
                    prepopulateFromStorage={true}
                    isClearable={true}
                  />
                </div>
              )}
              <div className="col-md-6">
                <Dropdown
                  label="Dealer Branch"
                  items={dealerBranches
                    .filter(
                      (x) =>
                        selectedGroup &&
                        x.dealerGroupId === selectedGroup.id &&
                        x.dealerBranchId !==
                          quote.dealerInformation.dealerBranchId &&
                        x.isoCurrencySymbol === quote.isoCurrencySymbol
                    )
                    .map((x) => ({
                      id: x.dealerBranchId,
                      label: x.dealerBranchName,
                    }))}
                  placeholder="Select a dealer branch..."
                  selectedId={selectedBranchId}
                  onChange={(selectedBranchId) =>
                    this.changeBranch(selectedBranchId)
                  }
                  isClearable={true}
                />
              </div>
            </div>
            <div className="row">
              <div className="col">
                <Dropdown
                  label="New Dealer Contact"
                  items={dealerUsers}
                  placeholder="Select a dealer contact..."
                  selectedId={selectedUserId}
                  onChange={(selectedUserId) =>
                    this.setState({ selectedUserId })
                  }
                  isClearable={true}
                />
              </div>
            </div>
            {appConfig.isManagementApp &&
              dealerGroup &&
              dealerBranch &&
              dealerUser && (
                <div className="row">
                  <div className="col">
                    <NotificationSettingsComponent
                      isEmailCommunicationEnabled={
                        dealerGroup.isEmailCommunicationEnabled
                      }
                      dealerGroupId={dealerGroup.id}
                      dealerGroupUsers={dealerUsers}
                      dealerUser={dealerUser}
                      amiUsers={amiUsers.filter(
                        (x) =>
                          x.id === quote.salesPersonId ||
                          x.id === quote.territoryManagerInformation.userId ||
                          dealerBranchSalesTeam.amiUserIds.includes(x.id) ||
                          quote.subscribedAmiUserIds.includes(x.id)
                      )}
                      isEditMode={true}
                      notificationSettings={notificationSettings}
                      onNotificationSettingsUpdate={
                        this.updateNotificationSettings
                      }
                      entityName="Quote"
                      defaultDealerContactIds={
                        dealerBranch.defaultDealerContactIds
                      }
                      enabledNotificationSchedule={false}
                    />
                  </div>
                </div>
              )}
          </form>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-secondary" onClick={this.hide}>
            Cancel
          </button>
          <Button
            label="Save"
            className="btn btn-primary"
            onClick={this.save}
            showSpinner={this.state.saving}
            disabled={selectedBranchId === null || selectedUserId === null}
          />
        </ModalFooter>
      </SimpleModal>
    );
  }
}
